export var FeatureToggles = {
  // WorkplaceOS Feature Flags
  WORKPLACE_OS: true
};